export const htmlStrip = (label: any) => {
  const d = document.createElement('div')
  d.innerHTML = label
  return d.innerText
}
